<div class="info-list has-info-icon py-3" [ngClass]="{ freemium: isFreemium }">
  <app-app-info-list-item [label]="'MFA Risk'"
    tooltipText="Pixalate's assessment of the likelihood of the website being deemed MFA, based on Pixalate's MFA detection methodology."
    [type]="'risk'" [value]="data?.mfa?.rating" [showFreemiumLock]="isFreemium"
    (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Ad Refresh Rate'"
    tooltipText="Number of ad impressions presented to a user, per minute." [value]="data?.mfa?.noOfAdsPerMin"
    [showFreemiumLock]="isFreemium" (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Ad Density'" tooltipText="Number of ad placements presented to a user, per minute."
    [value]="data?.mfa?.noOfPlacementIdsPerMin" [showFreemiumLock]="isFreemium"
    (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Social Traffic Rate'"
    tooltipText="Based on the amount of traffic sourced via social media." [type]="'percent'"
    [value]="data?.mfa?.socialRate" [showFreemiumLock]="isFreemium" (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
  <div class="divider"></div>
  <app-app-info-list-item [label]="'Paid Traffic Rate'"
    tooltipText="Based on the amount of traffic sourced via paid (ad) sources" [type]="'percent'"
    [value]="data?.mfa?.paidRate" [showFreemiumLock]="isFreemium" (goToSectionClick)="goToSection($event)">
  </app-app-info-list-item>
</div>